import React, { useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { BaseRole } from '../DefaultHeader';
import RouteKey from '../../routes/key';
import MenuSubItem from '../MenuSubItem';

const accessConfigurationLabel = 'Access Configuration';
const userGroupAccessConfigurationLabel = 'User Group and Access Configuration';
const accountManagementLabel = 'Account Management';

const {
  result,
  resit,
  exam,
  admin,
  appeal,
  accessArrangement,
  withdrawal,
  amendment,
  specialConsideration: special,
  usefulInformation: usefulInformationCandidate,
  statementOfResults,
  transaction,
} = RouteKey.child;

const applyResitId = 'apply-for-resit';
const registeredExamsLabel = 'Registered Exams';
const { candidate: transactionCandidate, coordinator: transactionCoordinator } =
  RouteKey.transaction.child;

const {
  configuration,
  tasklist,
  requestlist,
  userAccessConfiguration,
  accountManagement,
  iExams2Configuration,
  accessRole,
  orgAdminResultRelease,
  transactionLog,
  iExams2CandidateCreate,
  featuresConfiguration,
  auditSettings,
  oopAdminResitApply,
  oopAdminResitRegisteredExam,
  opAdminResultsAppeal,
  opAdminPaymentReport,
  candidateBlacklist,
  accessArrangementConfiguration,
  uniqueLink,
  withdrawalLink,
  opAdminRegistrationReport,
  specialConsideration,
  examConfiguration,
  announcementsConfiguration,
  nationalReport,
  nonNationalReport,
  nonNationalExamApplication,
  usefulInformation,
  oopAdminResultAppealAccess,
  specialConsiderationReport,
  opsAdminAccessArrangementReport,
  auditReport,
  dataArchivalReport,
  orgAdminNonNationalResult,
  manageAnnouncements,
  manageNotifications,
  notificationReport,
  userGroupAccessConfiguration,
  adminAccountManagement,
  userAccountManagement,
  dataArchival,
  profileAmendmentRequests,
  jobStatusReport,
} = RouteKey.admin.child;
const { applications, applicationsCoordinator } = RouteKey.appeal.child;

const { coordinatorResultList, myExaminations } = RouteKey.result.child;
const { listing, coordinatorListing, instruction, coordinatorResitRegister } = RouteKey.resit.child;
const {
  examRegistrations,
  registerExam,
  coordinatorRegisterExam,
  coordinatorExamRegistrations,
  coordinatorEntryProofs,
  nonNationalExaminations,
} = RouteKey.exam.child;

const { root: accessArrangementRoot, coordinatorRoot: accessArrangementCoordinatorRoot } =
  RouteKey['access-arrangement'].child;

const { root: statementOfResultsRoot } = RouteKey['statement-of-results'].child;

const { withdrawal: coordinatorWithdrawal } = RouteKey.withdrawal.child;

const { coordinatorExamRegistrations: coordinatorAmendmentExamRegistrations } =
  RouteKey.amendment.child;

const candidateAppealPathDetails = [`/${appeal}/${applications.route}`];
const candidateResitPathDetails = [
  `/${resit}/${instruction.route}`,
  `/${exam}/${examRegistrations.route}/${registerExam.route}`,
];
const candidateRegisterPathDetails = [
  `/${resit}/${listing.route}`,
  `/${usefulInformationCandidate}`,
];
const candidateResultsPathDetails = [`/${result}/${myExaminations.route}`];

const coordinatorResitPathDetails = [`/${resit}/${coordinatorResitRegister.route}`];
const coordinatorRegisterPathDetails = [
  `/${resit}/${coordinatorListing.route}`,
  `/${exam}/${coordinatorExamRegistrations.route}`,
  `/${exam}/${coordinatorEntryProofs.route}`,
];
const coordinatorResultsPathDetails = [`/${result}/${coordinatorResultList.route}`];
const coordinatorMakingRequestPathDetails = [
  `/${withdrawal}/${coordinatorWithdrawal.route}`,
  `/${amendment}/${coordinatorAmendmentExamRegistrations.route}`,
];

const adminApplicationsPathDetails = [
  `/${admin}/${orgAdminResultRelease.route}`,
  `/${admin}/${oopAdminResitApply.route}`,
  `/${admin}/${uniqueLink.route}`,
  `/${admin}/${usefulInformation.route}`,
];
const adminReportsPathDetails = [
  `/${admin}/${transactionLog.route}`,
  `/${admin}/${oopAdminResitRegisteredExam.route}`,
  `/${admin}/${opAdminResultsAppeal.route}`,
  `/${admin}/${opAdminPaymentReport.route}`,
  `/${admin}/${opAdminRegistrationReport.route}`,
  `/${admin}/${opsAdminAccessArrangementReport.route}`,
  `/${admin}/${auditReport.route}`,
  `/${admin}/${jobStatusReport.route}`,
];
const adminAccountsPathDetails = [
  `/${admin}/${accessRole.route}`,
  `/${admin}/${userAccessConfiguration.route}`,
  `/${admin}/${userGroupAccessConfiguration.route}`,
  `/${admin}/${accountManagement.route}`,
  `/${admin}/${iExams2CandidateCreate.route}`,
];
const adminSettingsPathDetails = [
  `/${admin}/${featuresConfiguration.route}`,
  `/${admin}/${auditSettings.route}`,
  `/${admin}/${iExams2Configuration.route}`,
  `/${admin}/${configuration.route}`,
];
const adminPersonalPathDetails = [`/${admin}/${tasklist.route}`, `/${admin}/${requestlist.route}`];

const registerForExamPsleId = 'register-for-exam-psle';
const registerForExamGceId = 'register-for-exam-gce';
const registerForExamIPsleId = 'register-for-exam-ipsle';
const registerForExamAeisId = 'register-for-exam-aeis';
const registerForExamSAeisId = 'register-for-exam-s-aeis';
const registerForExamSpersId = 'register-for-exam-spers';
const registerForExamSpersSecId = 'register-for-exam-spers-sec';
const accessArrangements = 'access-arrangements';
const specialConsiderationId = 'special-consideration';
const statementOfResultsId = 'statement-of-results';

export const useMenu = () => {
  const history = useHistory();
  const location = useLocation();

  const checkMenuPathsInLocation = (input: Array<string>) =>
    input.filter((item) => location.pathname.startsWith(item)).length > 0;
  const checkSubMenuPathInLocation = (value: string) => {
    const currentLocation = `${location.pathname}/`;
    return currentLocation.startsWith(`${value}/`);
  };

  return {
    history,
    checkMenuPathsInLocation,
    checkSubMenuPathInLocation,
  };
};

export interface UseHoverReturn {
  anchorEl: any;
  handleHover: (event: any) => void;
  handleEndHoverClose: () => void;
  timerCancel: () => void;
  handleClose: () => void;
}

export const useHover = (): UseHoverReturn => {
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const handleHover = (event: any) => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    setAnchorEl(event.currentTarget);
  };
  const handleEndHoverClose = () => {
    timer.current = setTimeout(() => {
      setAnchorEl(null);
    }, 500);
  };
  const timerCancel = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return {
    anchorEl,
    handleHover,
    handleEndHoverClose,
    timerCancel,
    handleClose,
  };
};

const candidateApplyExamList = (
  history: any,
  checkSubMenuPathInLocation: (value: string) => boolean
): (
  | {
      id?: string;
      idKey: string;
      label: string;
      navigate: () => void;
      isActiveSubMenu: boolean;
      isNonNationExam?: boolean;
    }
  | string
)[] => [
  'National Examinations',
  {
    id: registerForExamGceId,
    idKey: registerForExamGceId,
    label: 'GCE-Level Examination(s)',
    navigate: () => history.push(`/${exam}/${examRegistrations.route}/${registerExam.route}/GCE`),
    isActiveSubMenu: checkSubMenuPathInLocation(
      `/${exam}/${examRegistrations.route}/${registerExam.route}/GCE`
    ),
  },
  {
    id: applyResitId,
    idKey: 'resit',
    label: 'Register for Year-End MTL exam (After Mid-Year Results Release)',
    navigate: () => history.push(`/${resit}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${resit}/${instruction.route}`),
  },
  'Non-National Examinations',
  {
    id: registerForExamAeisId,
    idKey: registerForExamAeisId,
    label: 'Admissions Exercise for International Students (AEIS)',
    navigate: () =>
      history.push(`/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/aeis`),
    isActiveSubMenu: checkSubMenuPathInLocation(
      `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/aeis`
    ),
    isNonNationExam: true,
  },
  {
    id: registerForExamSAeisId,
    idKey: registerForExamSAeisId,
    label: 'Supplementary Admissions Exercise for International Students (S-AEIS)',
    navigate: () =>
      history.push(`/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/s-aeis`),
    isActiveSubMenu: checkSubMenuPathInLocation(
      `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/s-aeis`
    ),
    isNonNationExam: true,
  },
  {
    id: registerForExamSpersSecId,
    idKey: registerForExamSpersSecId,
    label: 'School Placement Exercise for Returning Singaporeans-Secondary (SPERS-Sec)',
    navigate: () =>
      history.push(
        `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/spers-sec`
      ),
    isActiveSubMenu: checkSubMenuPathInLocation(
      `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/spers-sec`
    ),
    isNonNationExam: true,
  },
  {
    id: registerForExamSpersId,
    idKey: registerForExamSpersId,
    label: 'Supplementary Placement Exercise (SPE)',
    navigate: () =>
      history.push(`/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/spe`),
    isActiveSubMenu: checkSubMenuPathInLocation(
      `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/spe`
    ),
    isNonNationExam: true,
  },
  '',
  {
    id: transaction,
    idKey: transaction,
    label: 'Transactions',
    navigate: () => history.push(`/${transaction}/${transactionCandidate.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${transaction}/${transactionCandidate.route}`),
  },
];

const CandidateMenu = () => {
  const { history, checkMenuPathsInLocation, checkSubMenuPathInLocation } = useMenu();

  const menuItem1 = useHover();
  const menuItem4 = useHover();
  const menuItem5 = useHover();
  const menuItem12 = useHover();

  return (
    <>
      <MenuSubItem
        {...menuItem1}
        handleHover={(evt) => {
          menuItem4.handleClose();
          menuItem5.handleClose();
          menuItem1.handleHover(evt);
        }}
        idKey="resit"
        label="Applying for Exams"
        subMap={candidateApplyExamList(history, checkSubMenuPathInLocation)}
        isActiveMenu={checkMenuPathsInLocation(candidateResitPathDetails)}
      />
      <MenuSubItem
        {...menuItem4}
        handleHover={(evt) => {
          menuItem1.handleClose();
          menuItem5.handleClose();
          menuItem12.handleClose();
          menuItem4.handleHover(evt);
        }}
        idKey="exams"
        label="Getting Ready for Exams"
        subMap={[
          {
            id: 'results',
            idKey: 'registeredExams',
            label: registeredExamsLabel,
            navigate: () => history.push(`/${exam}/${examRegistrations.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${exam}/${examRegistrations.route}`),
          },
          {
            id: 'usefulInformation',
            idKey: 'usefulInformation',
            label: 'Useful Information',
            navigate: () => history.push(`/${usefulInformationCandidate}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${usefulInformationCandidate}`),
          },
        ]}
        isActiveMenu={checkMenuPathsInLocation(candidateRegisterPathDetails)}
      />
      <MenuSubItem
        {...menuItem5}
        handleHover={(evt) => {
          menuItem1.handleClose();
          menuItem4.handleClose();
          menuItem12.handleClose();
          menuItem5.handleHover(evt);
        }}
        idKey="results"
        label="Getting Exam Results"
        subMap={[
          {
            id: 'results',
            idKey: 'results',
            label: 'Results',
            navigate: () => history.push(`/${result}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${result}/${myExaminations.route}`),
          },
        ]}
        isActiveMenu={checkMenuPathsInLocation(candidateResultsPathDetails)}
      />
      <MenuSubItem
        {...menuItem12}
        handleHover={(evt) => {
          menuItem1.handleClose();
          menuItem4.handleClose();
          menuItem5.handleClose();
          menuItem12.handleHover(evt);
        }}
        idKey="requests"
        label="Making Requests"
        subMap={[
          {
            id: 'requests',
            idKey: 'requests',
            label: 'Appeal for Review of Results',
            navigate: () => history.push(`/${appeal}/${applications.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${appeal}/${applications.route}`),
          },
          {
            id: accessArrangements,
            idKey: accessArrangements,
            label: 'Access Arrangements',
            navigate: () => history.push(`/${accessArrangement}/${accessArrangementRoot.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${accessArrangement}/${accessArrangementRoot.route}`
            ),
          },
          {
            id: specialConsiderationId,
            idKey: 'specialConsideration',
            label: 'Special Consideration',
            navigate: () => history.push(`/${special}/${specialConsideration.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${special}/${specialConsideration.route}`
            ),
          },
          {
            id: statementOfResultsId,
            idKey: statementOfResultsId,
            label: 'Statement of Results',
            navigate: () => history.push(`/${statementOfResults}/${statementOfResultsRoot.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${statementOfResults}/${statementOfResultsRoot.route}`
            ),
          },
        ]}
        isActiveMenu={checkMenuPathsInLocation(candidateAppealPathDetails)}
      />
    </>
  );
};

const CoordinatorMenu = () => {
  const { history, checkMenuPathsInLocation, checkSubMenuPathInLocation } = useMenu();

  const menuItem2 = useHover();
  const menuItem6 = useHover();
  const menuItem7 = useHover();
  const menuItem13 = useHover();

  return (
    <>
      <MenuSubItem
        {...menuItem2}
        handleHover={(evt) => {
          menuItem6.handleClose();
          menuItem7.handleClose();
          menuItem13.handleClose();
          menuItem2.handleHover(evt);
        }}
        idKey="register"
        label="Applying for Exams"
        subMap={[
          'Register for an Exam',
          {
            id: registerForExamPsleId,
            idKey: registerForExamPsleId,
            label: 'Primary School Leaving Examinations (PSLE)',
            navigate: () =>
              history.push(
                `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/PSLE`
              ),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/PSLE`
            ),
          },
          {
            id: registerForExamGceId,
            idKey: registerForExamGceId,
            label: 'GCE-Level Examination(s)',
            navigate: () =>
              history.push(
                `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/GCE`
              ),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/GCE`
            ),
          },
          {
            id: registerForExamIPsleId,
            idKey: registerForExamIPsleId,
            label: 'International Primary School Examinations (iPSLE)',
            navigate: () =>
              history.push(
                `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/IPSLE`
              ),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${exam}/${coordinatorExamRegistrations.route}/${coordinatorRegisterExam.route}/IPSLE`
            ),
          },
          {
            id: applyResitId,
            idKey: 'resit',
            label: 'Resit',
            navigate: () => history.push(`/${resit}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${resit}/${instruction.route}`),
          },
          {
            id: transaction,
            idKey: transaction,
            label: 'Transactions',
            navigate: () => history.push(`/${transaction}/${transactionCoordinator.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${transaction}/${transactionCoordinator.route}`
            ),
          },
        ]}
        isActiveMenu={checkMenuPathsInLocation(coordinatorResitPathDetails)}
      />
      <MenuSubItem
        {...menuItem6}
        handleHover={(evt) => {
          menuItem2.handleClose();
          menuItem7.handleClose();
          menuItem13.handleClose();
          menuItem6.handleHover(evt);
        }}
        idKey="exams"
        label="Getting Ready for Exams"
        subMap={[
          {
            id: 'registered-exams',
            idKey: 'registeredExams',
            label: registeredExamsLabel,
            // Temporary change to old resit listing path due to SIT ticket.
            navigate: () => history.push(`/${exam}/${coordinatorExamRegistrations.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${exam}/${coordinatorExamRegistrations.route}`
            ),
          },
          {
            id: 'entry-proof',
            idKey: 'entryProof',
            label: 'Entry Proof',
            navigate: () => history.push(`/${exam}/${coordinatorEntryProofs.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${exam}/${coordinatorEntryProofs.route}`),
          },
        ]}
        isActiveMenu={checkMenuPathsInLocation(coordinatorRegisterPathDetails)}
      />
      <MenuSubItem
        {...menuItem7}
        handleHover={(evt) => {
          menuItem2.handleClose();
          menuItem6.handleClose();
          menuItem13.handleClose();
          menuItem7.handleHover(evt);
        }}
        idKey="results"
        label="Getting Exam Results"
        subMap={[
          {
            id: 'results',
            idKey: 'results',
            label: 'Results',
            navigate: () => history.push(`/${result}/${coordinatorResultList.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${result}/${coordinatorResultList.route}`
            ),
          },
        ]}
        isActiveMenu={checkMenuPathsInLocation(coordinatorResultsPathDetails)}
      />
      <MenuSubItem
        {...menuItem13}
        handleHover={(evt) => {
          menuItem2.handleClose();
          menuItem6.handleClose();
          menuItem7.handleClose();
          menuItem13.handleHover(evt);
        }}
        idKey="requests"
        label="Making Requests"
        subMap={[
          {
            id: 'group-appeal-review',
            idKey: 'group-appeal-review',
            label: 'Appeal for Review of Results',
            navigate: () => history.push(`/${appeal}/${applicationsCoordinator.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${appeal}/${applicationsCoordinator.route}`
            ),
          },
          {
            id: 'group-access-arrangements',
            idKey: accessArrangements,
            label: 'Access Arrangements',
            navigate: () =>
              history.push(`/${accessArrangement}/${accessArrangementCoordinatorRoot.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${accessArrangement}/${accessArrangementCoordinatorRoot.route}`
            ),
          },
          {
            id: 'group-subject-amendment',
            idKey: 'subject-amendment',
            label: 'Subject Amendment',
            navigate: () =>
              history.push(`/${amendment}/${coordinatorAmendmentExamRegistrations.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${amendment}/${coordinatorAmendmentExamRegistrations.route}`
            ),
          },
          {
            id: 'withdrawal',
            idKey: 'withdrawal',
            label: 'Exam Withdrawal',
            navigate: () => history.push(`/${withdrawal}/${coordinatorWithdrawal.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${withdrawal}/${coordinatorWithdrawal.route}`
            ),
          },
          {
            id: specialConsiderationId,
            idKey: specialConsiderationId,
            label: 'Special Consideration',
            navigate: () => history.push(`/${special}/${specialConsideration.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${special}/${specialConsideration.route}`
            ),
          },
          {
            id: statementOfResultsId,
            idKey: statementOfResultsId,
            label: 'Statement of Results',
            navigate: () => history.push(`/${statementOfResults}/${statementOfResultsRoot.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${statementOfResults}/${statementOfResultsRoot.route}`
            ),
          },
        ]}
        isActiveMenu={checkMenuPathsInLocation(coordinatorMakingRequestPathDetails)}
      />
    </>
  );
};

const adminRegistrationReportMenuList = (
  history: any,
  checkSubMenuPathInLocation: (value: string) => boolean
): (
  | {
      id?: string;
      idKey: string;
      label: string;
      navigate: () => void;
      isActiveSubMenu: boolean;
    }
  | string
)[] => [
  'Registration Report',
  {
    idKey: 'nationalExam',
    label: 'GCE/PSLE/iPSLE',
    navigate: () =>
      history.push(`/${admin}/${opAdminRegistrationReport.route}/${nationalReport.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(
      `/${admin}/${opAdminRegistrationReport.route}/${nationalReport.route}`
    ),
  },
  {
    idKey: 'nonNationalExam',
    label: 'AEIS/S-AEIS/SPE/SPERS-Sec',
    navigate: () =>
      history.push(`/${admin}/${opAdminRegistrationReport.route}/${nonNationalReport.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(
      `/${admin}/${opAdminRegistrationReport.route}/${nonNationalReport.route}`
    ),
  },
  'Others',
  {
    idKey: 'accessArrangementReport',
    label: 'Access Arrangement Report',
    navigate: () => history.push(`/${admin}/${opsAdminAccessArrangementReport.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(
      `/${admin}/${opsAdminAccessArrangementReport.route}`
    ),
  },
  {
    idKey: 'appealReport',
    label: 'Appeal Report',
    navigate: () => history.push(`/${admin}/${opAdminResultsAppeal.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${opAdminResultsAppeal.route}`),
  },
  {
    idKey: 'auditReport',
    label: 'Audit Report',
    navigate: () => history.push(`/${admin}/${auditReport.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${auditReport.route}`),
  },
  {
    idKey: 'dataArchivalReport',
    label: 'Data Archival Report',
    navigate: () => history.push(`/${admin}/${dataArchivalReport.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${dataArchivalReport.route}`),
  },
  {
    idKey: 'resitReport',
    label: 'Resit Report',
    navigate: () => history.push(`/${admin}/${oopAdminResitRegisteredExam.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${oopAdminResitRegisteredExam.route}`),
  },
  {
    idKey: 'specialConsiderationReport',
    label: 'Special Consideration Report',
    navigate: () => history.push(`/${admin}/${specialConsiderationReport.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${specialConsiderationReport.route}`),
  },
  {
    idKey: 'paymentReport',
    label: 'Payment Report',
    navigate: () => history.push(`/${admin}/${opAdminPaymentReport.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${opAdminPaymentReport.route}`),
  },
  {
    idKey: 'notificationReport',
    label: 'Notification Report',
    navigate: () => history.push(`/${admin}/${notificationReport.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${notificationReport.route}`),
  },
  {
    idKey: 'transactionLog',
    label: 'Transaction Log',
    navigate: () => history.push(`/${admin}/${transactionLog.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${transactionLog.route}`),
  },
  {
    idKey: 'jobStatusReport',
    label: 'Job Status Report',
    navigate: () => history.push(`/${admin}/${jobStatusReport.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${jobStatusReport.route}`),
  },
];

const adminApplicationMenuList = (
  history: any,
  checkSubMenuPathInLocation: (value: string) => boolean
): (
  | {
      id?: string;
      idKey: string;
      label: string;
      navigate: () => void;
      isActiveSubMenu: boolean;
    }
  | string
)[] => [
  'National Examination',
  {
    idKey: 'appeal',
    label: 'Appeal',
    navigate: () => history.push(`/${admin}/${oopAdminResultAppealAccess.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${oopAdminResultAppealAccess.route}`),
  },
  {
    idKey: 'examRegistrationNational',
    label: 'Exam Registration',
    navigate: () => history.push(`/${admin}/${uniqueLink.route}/national`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${uniqueLink.route}/national`),
  },
  {
    idKey: 'examWithdrawalNational',
    label: 'Exam Withdrawal',
    navigate: () => history.push(`/${admin}/${withdrawalLink.route}/national`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${withdrawalLink.route}/national`),
  },
  {
    idKey: 'resit',
    label: 'Resit',
    navigate: () => history.push(`/${admin}/${oopAdminResitApply.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${oopAdminResitApply.route}`),
  },
  'Non-National Examination',
  {
    idKey: 'reviewApplicationNonNational',
    label: 'Applications Review',
    navigate: () => history.push(`/${admin}/${nonNationalExamApplication.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${nonNationalExamApplication.route}`),
  },
  {
    idKey: 'examRegistrationNonNational',
    label: 'Exam Registration',
    navigate: () => history.push(`/${admin}/${uniqueLink.route}/non-national`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${uniqueLink.route}/non-national`),
  },
  'Results',
  {
    idKey: 'results',
    label: 'GCE/PSLE/iPSLE Examination',
    navigate: () => history.push(`/${admin}/${orgAdminResultRelease.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${orgAdminResultRelease.route}`),
  },
  {
    idKey: 'nonNationalExaminationResult',
    label: 'Non-National Examination',
    navigate: () => history.push(`/${admin}/${orgAdminNonNationalResult.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${orgAdminNonNationalResult.route}`),
  },
  'Others',
  {
    idKey: 'useful-information',
    label: 'Useful Information',
    navigate: () => history.push(`/${admin}/${usefulInformation.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${usefulInformation.route}`),
  },
  {
    idKey: 'manage-announcements',
    label: 'Manage Announcements',
    navigate: () => history.push(`/${admin}/${manageAnnouncements.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${manageAnnouncements.route}`),
  },
  {
    idKey: 'manage-notifications',
    label: 'Manage Notifications',
    navigate: () => history.push(`/${admin}/${manageNotifications.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${manageNotifications.route}`),
  },
  {
    idKey: 'profile-amendment-requests',
    label: 'Profile Amendment Requests',
    navigate: () => history.push(`/${admin}/${profileAmendmentRequests.route}`),
    isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${profileAmendmentRequests.route}`),
  },
];

const AdminMenu = () => {
  const { history, checkMenuPathsInLocation, checkSubMenuPathInLocation } = useMenu();

  const menuItem3 = useHover();
  const menuItem8 = useHover();
  const menuItem9 = useHover();
  const menuItem10 = useHover();
  const menuItem11 = useHover();

  return (
    <>
      <MenuSubItem
        {...menuItem3}
        handleHover={(evt) => {
          menuItem8.handleClose();
          menuItem9.handleClose();
          menuItem10.handleClose();
          menuItem11.handleClose();
          menuItem3.handleHover(evt);
        }}
        idKey="applications"
        label="Applications"
        subMap={adminApplicationMenuList(history, checkSubMenuPathInLocation)}
        isActiveMenu={checkMenuPathsInLocation(adminApplicationsPathDetails)}
      />
      <MenuSubItem
        {...menuItem8}
        handleHover={(evt) => {
          menuItem3.handleClose();
          menuItem9.handleClose();
          menuItem10.handleClose();
          menuItem11.handleClose();
          menuItem8.handleHover(evt);
        }}
        idKey="reports"
        label="Reports"
        subMap={adminRegistrationReportMenuList(history, checkSubMenuPathInLocation)}
        isActiveMenu={checkMenuPathsInLocation(adminReportsPathDetails)}
      />
      <MenuSubItem
        {...menuItem9}
        handleHover={(evt) => {
          menuItem3.handleClose();
          menuItem8.handleClose();
          menuItem10.handleClose();
          menuItem11.handleClose();
          menuItem9.handleHover(evt);
        }}
        idKey="accounts"
        label="Accounts"
        subMap={[
          'Admin',
          {
            idKey: 'adminAccountManagement',
            label: accountManagementLabel,
            navigate: () => history.push(`/${admin}/${adminAccountManagement.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${admin}/${adminAccountManagement.route}`
            ),
          },
          {
            idKey: 'userGroupAccessConfiguration',
            label: userGroupAccessConfigurationLabel,
            navigate: () => history.push(`/${admin}/${userGroupAccessConfiguration.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${admin}/${userGroupAccessConfiguration.route}`
            ),
          },
          'User',
          // {
          //   label: 'User Group',
          //   navigate: () => history.push(`/${admin}/${userGroupManagement}`),
          // },
          {
            idKey: 'userAccessConfiguration',
            label: accessConfigurationLabel,
            navigate: () => history.push(`/${admin}/${userAccessConfiguration.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${admin}/${userAccessConfiguration.route}`
            ),
          },
          {
            idKey: 'userAccountManagement',
            label: accountManagementLabel,
            navigate: () => history.push(`/${admin}/${userAccountManagement.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${userAccountManagement.route}`),
          },
          {
            idKey: 'bulkCandidateCreation',
            label: 'Bulk Candidate Creation',
            navigate: () => history.push(`/${admin}/${iExams2CandidateCreate.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${admin}/${iExams2CandidateCreate.route}`
            ),
          },
          {
            idKey: 'candidateBlacklist',
            label: 'Candidate Blacklist',
            navigate: () => history.push(`/${admin}/${candidateBlacklist.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${candidateBlacklist.route}`),
          },
        ]}
        isActiveMenu={checkMenuPathsInLocation(adminAccountsPathDetails)}
      />
      <MenuSubItem
        {...menuItem10}
        handleHover={(evt) => {
          menuItem3.handleClose();
          menuItem8.handleClose();
          menuItem9.handleClose();
          menuItem11.handleClose();
          menuItem10.handleHover(evt);
        }}
        idKey="settings"
        label="Settings"
        subMap={[
          {
            idKey: 'featuresConfiguration',
            label: 'Features Configuration',
            navigate: () => history.push(`/${admin}/${featuresConfiguration.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${featuresConfiguration.route}`),
          },
          {
            idKey: 'auditSettings',
            label: 'Audit Setting',
            navigate: () => history.push(`/${admin}/${auditSettings.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${auditSettings.route}`),
          },
          // {
          //   idKey: 'iexams2Configuration',
          //   label: 'iEXAMS2 Configuration',
          //   navigate: () => history.push(`/${admin}/${iExams2Configuration.route}`),
          //   isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${iExams2Configuration.route}`),
          // },

          {
            idKey: 'systemSettings',
            label: 'System Settings',
            navigate: () => history.push(`/${admin}/${configuration.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${configuration.route}`),
          },
          {
            idKey: 'dataArchival',
            label: 'Data Archival',
            navigate: () => history.push(`/${admin}/${dataArchival.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${dataArchival.route}`),
          },
          {
            idKey: 'accessArrangementConfiguration',
            label: 'Access Arrangements Configuration',
            navigate: () => history.push(`/${admin}/${accessArrangementConfiguration.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${admin}/${accessArrangementConfiguration.route}`
            ),
          },
          {
            idKey: 'examConfiguration',
            label: 'Non-National Exam Configuration',
            navigate: () => history.push(`/${admin}/${examConfiguration.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${examConfiguration.route}`),
          },
          {
            idKey: 'announcementsConfiguration',
            label: 'Announcements Configuration',
            navigate: () => history.push(`/${admin}/${announcementsConfiguration.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(
              `/${admin}/${announcementsConfiguration.route}`
            ),
          },
        ]}
        isActiveMenu={checkMenuPathsInLocation(adminSettingsPathDetails)}
      />
      <MenuSubItem
        {...menuItem11}
        handleHover={(evt) => {
          menuItem3.handleClose();
          menuItem8.handleClose();
          menuItem9.handleClose();
          menuItem10.handleClose();
          menuItem11.handleHover(evt);
        }}
        idKey="personal"
        label="Personal"
        subMap={[
          {
            idKey: 'myTasks',
            label: 'My Tasks',
            navigate: () => history.push(`/${admin}/${tasklist.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${tasklist.route}`),
          },
          {
            idKey: 'myRequests',
            label: 'My Requests',
            navigate: () => history.push(`/${admin}/${requestlist.route}`),
            isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${requestlist.route}`),
          },
        ]}
        isActiveMenu={checkMenuPathsInLocation(adminPersonalPathDetails)}
      />
    </>
  );
};

const DesktopMenu = ({ baseRole }: { baseRole: BaseRole }) => (
  <>
    {baseRole && baseRole === 'CANDIDATE' && <CandidateMenu />}

    {baseRole && baseRole === 'COORDINATOR' && <CoordinatorMenu />}

    {baseRole && baseRole === 'ADMIN' && <AdminMenu />}
  </>
);

export default DesktopMenu;
